const EMAIL_RE = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function normalizeEmail(email) {
  return (email || '').trim().toLowerCase();
}

export function isValidEmail(email) {
  const e = normalizeEmail(email);
  if (!e || e.length > 254) return false;
  return EMAIL_RE.test(e);
}

export function emailValidationMessage(email) {
  if (!normalizeEmail(email)) return 'Email is required';
  if (!isValidEmail(email)) return 'Enter a valid email address';
  return null;
}
